export const determineMemoryBoardClasses = (nbrColumns, displayFriendChk, gameType) => {
    let containerClass = "memoryGameContainer";
    let newBoardClass = "memoryBoard memoryBoardAdded";
    if (displayFriendChk === true){
        containerClass += "-friend";
        newBoardClass = "memoryBoard-friend memoryBoardAdded";
    }
   
    let cardType = "";
    if (gameType === "Volunteer"){
        cardType = "book-cover cover-size";
    }else{
        cardType = "back cover-size";
    }
     
    let addOnClass = "";
    switch (nbrColumns){
        case 4:
            addOnClass = " memoryBoard4Columns";
            break;
        case 5:
            addOnClass = " memoryBoard5Columns";
            break;
        case 6:
            addOnClass = " memoryBoard6Columns";
            break;
        default:
            break;
    }
    newBoardClass = newBoardClass + addOnClass;
    const returnObj={containerClass: containerClass, boardClass: newBoardClass, cardType: cardType,}
    return returnObj;
}
export default determineMemoryBoardClasses;